export const PAID_MODE_GROUP = [
    {
        idx: 1,
        label: "신용카드",
        name: "card",
    },
    // {
    //     idx: 2,
    //     label: "네이버 페이",
    //     name: "naverpay",
    // },
    // {
    //     idx: 3,
    //     label: "카카오 페이",
    //     name: "kakaopay",
    // },
    {
        idx: 4,
        label: "무통장",
        name: "account",
    },
];
